export default __webpack_public_path__ + "static/media/gifv1.c055cb5e.gif";